import axios from 'axios'
import router from '../router';

// axios 配置
// axios.defaults.timeout = 5000;
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
// axios.defaults.baseURL = 'http://localhost:8080';

axios.defaults.baseURL = '/apiNQ/'


//拦截器：发送请求前处理
//POST传参序列化
axios.interceptors.request.use((config) => {
  if (config.method === 'post') {
    // config.data = qs.stringify(config.data);  qs.stringify对应的是application/x-www-form-urlencoded方式
  }
  return config;
}, (error) => {
  return Promise.reject(error);
});

//拦截器：接收返回后,回调之前处理
//返回状态判断
axios.interceptors.response.use((res) => {
  // 假如未登录或者无权限
  // if (res.data.code === 24||res.data.code === 25) {
  //   return Promise.reject(res);
  // }
  return res;
}, (error) => {
  //404等问题可以在这里处理
  return Promise.reject(error);
});

//业务方法
//==============GET==================
export function get(url, params = {}) {
  //数据拼接字符串
  let dataStr = '';
  Object.keys(params).forEach(key => {
    dataStr += key + '=' + params[key] + '&';
  })

  if (dataStr !== '') {
    dataStr = dataStr.substr(0, dataStr.lastIndexOf('&'));
    url = url + '?' + dataStr;
  }

  return new Promise((resolve, reject) => {
    axios({
      url: url,
      method: 'get',
      headers: { 'Content-Type': 'application/json', "token": window.localStorage.getItem('user') }
    })
      .then(response => {
        if (response.data.code === 1) {
          resolve(response.data);
        } else if (response.data.code === 24) {
          alert(response.data.message);
          router.push({ path: "/login" });
        } else if (response.data.code === -1) {
          alert(response.data.message);
          // router.push({ path: "/login" });
        }

      }, err => {
        alert("失败11");
        reject(err);
      })
      .catch((error) => {
        reject(error)
      });
  })
};

//==============POST==================
export function post(url, params) {
  return new Promise((resolve, reject) => {
    // 判断是从用户端还是管理端进入的
    let appFlag = params.appFlag;
    let token;
    if (appFlag != null && appFlag != undefined && appFlag === 1) {
      token = window.localStorage.getItem('app_user_token')
    } else {
      token = window.localStorage.getItem('user')
    }

    axios({
      url: url,
      method: 'post',
      data: params,
      headers: { 'Content-Type': 'application/json', "token": token }
    }).then(response => {
      if (response.data.code === 1 || response.data.code === 2) {
        resolve(response.data);
      } else if (response.data.code === 24) {
        alert(response.data.message);
        if (appFlag && appFlag == 1) {
          window.location.href = "https://epc.yiec.com/";   // TODO
        } else {
          router.push({ path: "/login" });
        }
      } else if (response.data.code === -1) {
        alert(response.data.message);
        if (appFlag && appFlag == 1) {
          window.location.href = "https://epc.yiec.com/";   // TODO
        }
        // router.push({ path: "/login" });
      }
    }, err => {
      reject(err);
    }).catch((error) => {
      reject(error)
    });
  })
}

//==============DELETE==================
export function del(url) {
  return new Promise((resolve, reject) => {
    axios({
      url: url,
      method: 'delete',
      headers: { 'Content-Type': 'application/json', "token": window.localStorage.getItem('user') }
    }).
      then(response => {
        if (response.data.code === 1) {
          resolve(response.data);
        } else if (response.data.code === 24) {
          alert(response.data.message);
          router.push({ path: "/login" });
        } else if (response.data.code === -1) {
          alert(response.data.message);
          // router.push({ path: "/login" });
        }

      }, err => {
        reject(err);
      }).catch((error) => {
        reject(error)
      });
  })
}








// WEBPACK FOOTER //
// ./src/axios/index.js